module.exports = __webpack_public_path__ + "img/card-t5.b4814811.png";